import { gql } from "@apollo/client";

/**
 * The Timeline's You view: the reader's own steps in a review, with dates.
 * Built by the backend from the same dated plan as the Setup view.
 */
export default gql`
  query getComplianceProgramMyTimeline($complianceProgramId: Int!) {
    complianceProgram(pk: $complianceProgramId) {
      id
      myTimeline {
        steps {
          date
          step
          label
          who
          state
        }
        notes
      }
    }
  }
`;
